import { GetActivitiesSections_getActivitiesSections } from 'approot/activity-builder/__generated__/GetActivitiesSections';
import { ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION } from 'global/constants';
import { ComponentRiveAnimation } from '../../component.constants';
import { preloadFiles } from 'approot/shared/logic/preload-files';
import { getComponentsOfType } from './get-components-of-type';

export function preloadRiveFiles(
  section: GetActivitiesSections_getActivitiesSections
) {
  const components = getComponentsOfType<ComponentRiveAnimation>({
    components: section.components,
    types: [ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION],
  });
  const urls: string[] = [];

  components.forEach(c => {
    if (c.properties.rive.link) {
      urls.push(c.properties.rive.link);
    }
  });

  preloadFiles(urls);
}
